const Config = {
  appVersion: "1.0",
  defaultPageTitle: "Horizon Sails & Membranes",
  apiUrl: process.env.REACT_APP_API_URL,
  gtmId: process.env.REACT_APP_GTM_ID,
};

export default Config;
